module.exports = __webpack_public_path__ + "media/images/help-arrow-598a3391c483cc6aaa114180da59ae9d.svg";